
/**
 * @descripttion: 店铺状态
 */

export const Shop_Status=  {
  1: '营业中',
  2: '休息中',
  3: '超出配送范围',
  4: '暂停配送',
  5: '休息中',
}

// 商家自配送
export const STORE_DELIVERY = 2